import React, {Component} from 'react';
import Header from '../Header/Header'
import SpyMenu from '../../Elements/SpyMenu'
import MenuCard from '../Main/MenuCard';
import Footer from '../Footer/Footer';
import {ToastContainer} from 'react-toastify'
import getMenu, {getDefaultForSlug} from '../../Services/API/menuAPI';
import {Container, Row, Col} from 'react-bootstrap';
import { withRouter } from "react-router";

class Menu extends Component { 
    state ={
        menu: {},
        lang: "nl",
      };

      handleLanguageChange = (e) =>{
        let lang = e.target.value
        this.setState({lang});
        this.props.handleLanguageChange(lang);
      }
    
      async componentDidMount() {
        const menuId = this.props.match.params.menuId;
        const slug = this.props.match.params.slug;
        const {data} = (menuId == null?await getDefaultForSlug(slug):await getMenu(menuId));
        const menu = {...data};
        this.setState({menu});
      }

    render(){
        return(  
            <div>
        <ToastContainer />
            <Header handleLanguageChange={this.handleLanguageChange} lang={this.state.lang} restaurant={this.state.menu.restaurant}/>
            <SpyMenu categories={this.state.menu.menuCategories} lang={this.state.lang}/>
            <Container fluid>
              <Row>
                <Col>
                  <MenuCard name={this.state.menu.name} categories={this.state.menu.menuCategories} lang={this.state.lang}/>
                </Col>
              </Row>
            </Container>
            <Footer lang={this.state.lang}/>  
            </div> 
            )
    } 

 }

export default withRouter(Menu);